async function store(data, options = {}) {
    const response = await window.axios.post('/api/s3/signed-storage-url', {
        'bucket': options.bucket || '',
        'content_type': options.contentType || data.type,
        'expires': options.expires || '',
        'visibility': options.visibility || '',
        ...options.data
    }, {
        baseURL: options.baseURL || null,
        headers: options.headers || {},
        ...options.options
    });

    let headers = response.data.headers;

    if ('Host' in headers) {
        delete headers.Host;
    }

    if (typeof options.progress === 'undefined') {
        options.progress = () => {
        };
    }

    const cancelToken = options.cancelToken || ''

    await window.axios.put(response.data.url, data, {
        cancelToken: cancelToken,
        headers: headers,
        onUploadProgress: (progressEvent) => {
            options.progress(progressEvent.loaded / progressEvent.total);
        }
    })

    if (data.name) {
        response.data.extension = data.name.split('.').pop()
    }

    return response.data;
}

export { store }
